import React from 'react';
import {createPortal} from "react-dom";

const Loader = ({children, textCenter = false}) => {
    return createPortal(
        <div id={"loader"} className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center pointer-events-auto">
            <div className={`flex items-center ${textCenter ? "relative justify-center" : ""}`}>
                <div
                    className="inline-block h-52 w-52 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] text-gray-300"
                    role="status">
                </div>
                {textCenter ?
                    <div className="absolute inset-0 flex items-center justify-center p-4 text-center text-white">
                        {children}
                    </div>
                    :
                    children
                }

            </div>
        </div>,
        document.body
    );
};

export default Loader;